import { CHART_HEIGHT, chartFontSize } from "./consts";

export function getChangeTrackingBaseChartConfig(): Highcharts.Options {
  return {
    chart: {
      height: 250,
      marginTop: 30,
      animation: true,
      style: {
        fontFamily: 'Inter, sans-serif'
      }
    },
    credits: {
      enabled: false
    },
    legend: {
      enabled: true,
      itemStyle: {
        fontSize: '12px'
      }
    },
    plotOptions: {
      series: {
        marker: {
          enabled: true,
          radius: 3
        },
        animation: {
          duration: 500
        }
      }
    }
  };
}

export const getPerformanceBaseChartConfig = () => {
  return {
    chart: {
      height: CHART_HEIGHT,
      marginTop: 30,
      style: {
        fontFamily: 'inherit',
        fontSize: chartFontSize
      }
    },
    responsive: {
      rules: [{
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          legend: {
            enabled: false
          }
        }
      }]
    },
    credits: {
      enabled: false
    },
    time: {
      useUTC: false
    },
    xAxis: {
      type: 'datetime',
      labels: {
        format: '{value:%Y-%m-%d}'
      }
    },
    legend: {
      enabled: true,
      itemStyle: {
        fontSize: chartFontSize
      },
      itemHoverStyle: {
        color: '#000000'
      }
    },
    plotOptions: {
      series: {
        marker: {
          enabled: true,
          radius: 3
        },
      }
    }
  };
};
